enum ELoadingState {
  Idle,
  Loading,
  Loaded,
  Failed,
}

export default ELoadingState;
